import React from "react";

const NoResult = () => {
  return (
    <div
      data-testid="NoResult"
      style={{
        padding: "50px 30px 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      No results
    </div>
  );
};

export default NoResult;
